
// import React, { forwardRef } from "react";
// import moment from "moment";
// import { CONSTANTS } from "config/constant";

// const Invoice = forwardRef(({ order }, ref) => {
//   const userDataString = localStorage.getItem("userData");
//   const userData = JSON.parse(userDataString);
//   if (!order) return null;
//   const image =
//     CONSTANTS?.BACKEND_URL + userData?.data?.profile_image?.[0]?.file_url;
//   const {
//     order_user_info,
//     order_pickup_address,
//     order_delivery_address,
//     order_pickup_time,
//     order_id,
//     created_at,
//     payment_type,
//     delivery_fee,
//     total,
//     currency,
//     items,
//   } = order;
//   const superAdminInfo = {
//     logoUrl: image,
//     contact: {
//       name: "SuperAdmin Name",
//       email: "admin@example.com",
//       phone: "+1234567890",
//     },
//   };

//   return (
//     <div
//       className="flex flex-col items-center justify-center rounded-lg bg-white p-4 shadow-md"
//       ref={ref}
//     >
//       <div className="mb-4 flex flex-col items-center justify-between">
//         <div>
//           <img src={superAdminInfo.logoUrl} alt="Logo" className="h-auto w-16" />
//         </div>
//         <div className="text-right">
//           <p className="font-semibold">{superAdminInfo.contact.name}</p>
//           <p>{superAdminInfo.contact.email}</p>
//           <p>{superAdminInfo.contact.phone}</p>
//         </div>
//       </div>
//       <div className="mb-4">
//         <h2 className="mb-2 text-xl font-semibold">Invoice</h2>
//         <p className="mb-1">Order ID: {order_id}</p>
//         <p className="mb-1">
//           Customer:{" "}
//           {order_user_info?.first_name + " " + order_user_info?.last_name}
//         </p>
//         <p className="mb-1">House No: {order_pickup_address?.house_number}</p>
//         <p className="mb-1">Road No: {order_pickup_address?.road_number}</p>
//         <p className="mb-1">Phone No: {order_user_info?.phone}</p>
//         <p>Pick Date: {moment.unix(order_pickup_time).format("MMM DD, YYYY")}</p>
//       </div>
//       <div className="mb-4">
//         <h3 className="mb-2 text-lg font-semibold">Items</h3>
//         {items.map((item, index) => (
//           <p key={index} className="mb-1">
//             {item.name} <br />
//             {item.quantity} x {currency}
//             {item.price} = {currency}
//             {item.quantity * item.price}
//           </p>
//         ))}
//         <p className="mb-1">TOTAL: {currency}{total}</p>
//         <p className="mb-1">DELIVERY COST: {currency}{delivery_fee}</p>
//         <p className="mb-1">TOTAL PAYABLE: {currency}{total}</p>
//         <p className="mb-1">
//           Total PCs: {items.reduce((sum, item) => sum + item.quantity, 0)}
//         </p>
//         <p className="mb-1">Paid By: {payment_type}</p>
//         <p>Total: {currency}{total}</p>
//       </div>
//       <div>
//         <p className="text-gray-600">Thank you for choosing LAUNDRY</p>
//       </div>
//     </div>
//   );
// });

// export default Invoice;
import React, { forwardRef } from "react";
import moment from "moment";
import { CONSTANTS } from "config/constant";

const Invoice = forwardRef(({ order }, ref) => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);

  if (!order) return null;

  const image =
    CONSTANTS?.IMG_DIRECTORY + userData?.data?.profile_image?.[0]?.file_url;

  const {
    order_user_info,
    order_pickup_address,
    order_delivery_address,
    order_pickup_time,
    order_id,
    created_at,
    payment_type,
    delivery_fee,
    total,
    currency,
    items,
  } = order;

  const superAdminInfo = {
    logoUrl: image,
    contact: {
      name: "SuperAdmin Name",
      email: "admin@example.com",
      phone: "+1234567890",
    },
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="flex flex-col items-center justify-center rounded-lg bg-white p-4 shadow-md" ref={ref}>
      <div className="mb-4 flex flex-col items-center justify-between">
        <div>
          <img src={superAdminInfo.logoUrl} alt="Logo" className="h-auto w-16" />
        </div>
        <div className="text-right">
          <p className="font-semibold">{superAdminInfo.contact.name}</p>
          <p>{superAdminInfo.contact.email}</p>
          <p>{superAdminInfo.contact.phone}</p>
        </div>
      </div>
      <div className="mb-4">
        <h2 className="mb-2 text-xl font-semibold">Invoice</h2>
        <p className="mb-1">Order ID: {order_id}</p>
        <p className="mb-1">
          Customer: {order_user_info?.first_name + " " + order_user_info?.last_name}
        </p>
        <p className="mb-1">House No: {order_pickup_address?.house_number}</p>
        <p className="mb-1">Road No: {order_pickup_address?.road_number}</p>
        <p className="mb-1">Phone No: {order_user_info?.phone}</p>
        <p>
          Pick Date: {moment.unix(order_pickup_time).format("MMM DD, YYYY")}
        </p>
      </div>
      <div className="mb-4">
        <h3 className="mb-2 text-lg font-semibold">Items</h3>
        {items.map((item, index) => (
          <p key={index} className="mb-1">
            {item.name} <br />
            {item.quantity} x {currency}
            {item.price} = {currency}
            {item.quantity * item.price}
          </p>
        ))}
        <p className="mb-1">TOTAL: {currency}{total}</p>
        <p className="mb-1">DELIVERY COST: {currency}{delivery_fee}</p>
        <p className="mb-1">TOTAL PAYABLE: {currency}{total}</p>
        <p className="mb-1">
          Total PCs: {items.reduce((sum, item) => sum + item.quantity, 0)}
        </p>
        <p className="mb-1">Paid By: {payment_type}</p>
        <p>Total: {currency}{total}</p>
      </div>
      <div>
        <p className="text-gray-600">Thank you for choosing LAUNDRY</p>
      </div>
    </div>
  );
});

export default Invoice;
